import axios from "axios";

export function cancelStockTake(id) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/stocktake/${id}/cancel`, {})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
